import { Layout } from '@/components/layout/Layout';
import { LedgersPage } from './LedgersPage';

export function AssetsPage() {
    return (
        <Layout>
            <LedgersPage type="asset" />
        </Layout>
    );
}
